import store from "../../store";
import {httpReq} from "@/htttpReq";

export default {
  namespaced: true,

  state: {
    settings: {}
  },

  getters: {
    settings(state) {
      return state.settings;
    }
  },

  mutations: {
    setSettings(state, payload) {
      state.settings = payload;
    }
  },

  actions: {
    getSettings({commit}) {
      httpReq.get('order/settings/get-settings',
        {
          params: {
            order_id: this.getters['orderPreview/id'],
          }
        }
      )
        .then(response => {
          commit('setSettings', response.data.data);
        })
        .catch(error => {
          store.commit('errorsModal/openModal', error.response.data.errors);
        })
        .finally(() => {})
    },

    putTimeRequired({state, dispatch}) {
      httpReq.put('order/settings/change-time-required',
        {
          order_id: this.getters['orderPreview/id'],
          installation_time: state['settings'].installation_time,
        }
      )
        .then(response => {
          if(response.status === 200){
            dispatch('getSettings');
              store.dispatch('orderPreview/getPreview', true);
          }
        })
        .catch(error => {
          store.commit('errorsModal/openModal', error.response.data.errors);
        })
        .finally(() => {})
    },

    putFreInstallation({state, dispatch}) {
      httpReq.put('order/settings/change-free-installation',
        {
          order_id: this.getters['orderPreview/id'],
          installation_time: state['settings'].free_installation,
        }
      )
        .then(response => {
          if(response.status === 200){
            dispatch('getSettings');
              store.dispatch('orderPreview/getPreview', true);
          }
        })
        .catch(error => {
          store.commit('errorsModal/openModal', error.response.data.errors);
        })
        .finally(() => {})
    },

    putFixedFee({state, dispatch}) {
      httpReq.put('order/settings/change-fixed-fee',
        {
          order_id: this.getters['orderPreview/id'],
          value: state['settings'].installation_fee,
        }
      )
        .then(response => {
          if(response.status === 200){
            dispatch('getSettings');
              store.dispatch('orderPreview/getPreview', true);
          }
        })
        .catch(error => {
          store.commit('errorsModal/openModal', error.response.data.errors);
        })
        .finally(() => {})
    },

    putMinRate({state, dispatch}) {
      httpReq.put('order/settings/change-min-rate',
        {
          order_id: this.getters['orderPreview/id'],
          value: state['settings'].min_rate_value,
        }
      )
        .then(response => {
          if(response.status === 200){
            dispatch('getSettings');
              store.dispatch('orderPreview/getPreview', true);
          }
        })
        .catch(error => {
          store.commit('errorsModal/openModal', error.response.data.errors);
        })
        .finally(() => {})
    },

      changeDiscount({state, dispatch}) {
          httpReq.put('order/settings/change-discount',
              {
                  order_id: this.getters['orderPreview/id'],
                  pct: state['settings'].discount_pct,
                  amt: state['settings'].discount_amt,
                  type: state['settings'].discount_type,
              }
          )
              .then(response => {
                  if(response.status === 200){
                      dispatch('getSettings');
                      store.dispatch('orderPreview/getPreview', true);
                  }
              })
              .catch(error => {
                  store.commit('errorsModal/openModal', error.response.data.errors);
              })
              .finally(() => {})
      },


  },
};
